<template>
  <div>
    <v-card>
      <v-card-title class="headline grey lighten-2" primary-title>
        List of Child Account
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            v-bind:options.sync="pagination"
            item-key="name"
            :loading="loading"
            :no-data-text="noDataText"
            :custom-filter="customSearch"
          >
            <template v-slot:item="row"
              ><tr>
                <td class="text-xs-left">{{ row.item.glacctNo }}</td>
                <td class="text-xs-left">{{ row.item.fund }}</td>
                <td class="text-xs-left">{{ row.item.acctNoSfx }}</td>
                <td class="text-xs-left">{{ row.item.description }}</td>
              </tr></template
            >
          </v-data-table>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      headers: [
        { text: 'GL Account No.', value: 'glacctNo' },
        { text: 'Fund', value: 'fund' },
        { text: 'Account No. Sfx', value: 'acctNoSfx' },
        { text: 'Description', value: 'description' }
      ],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    async doInit() {
      const apiURI = this.menu.srchChild
      if (apiURI) {
        this.loading = true
        this.items = []
        const expand = this.glacctNoId
        this.$http
          .get(expandURI(apiURI, expand))
          .then((result) => {
            const { data } = result.data
            if (data) {
              data.map((child) => {
                const convertList = {
                  glacctNo: child.glacctNo,
                  fund: child.fund,
                  acctNoSfx: child.acctNoSfx,
                  description: child.description
                }
                this.items.push(convertList)
              })
            }
            this.loading = false
          })
          .catch((err) => {
            this.loading = false
            const { data } = err.response
            if (data) {
              this.message(data)
              this.fieldMessage(data)
            }
          })
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.glAcctParam.menu
    },
    glacctNoId() {
      return this.$store.state.glAcctParam.glAcctNo.glAcctNoId
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
